import { API } from "./APIClient";

class SuperAdminAPIClass {
    async fetchCafes() {
        const response = await API.get(`/sadmin/cafe/allInfo`);

        const result = [];
        for (const item of response.data.cafes) {
            result.push({
                id: item.id,
                name: item.name,
                address: item.address,
                group: item.group,
                maxEmpCount: item.max_emp_count,
            })
        }

        return result;
    }

    async deleteCafe(cafeId) {
        const response = await API.delete(`/sadmin/cafe/deleteCafe/${cafeId}`);

        return response.data;
    }

    async updateCafeInfo(cafeId, data) {
        const response = await API.patch(`/sadmin/cafe/updateInfo`, {
            cafe_id: cafeId,
            name: data.name,
            address: data.address,
            group: data.group,
            max_emp_count: data.maxEmpCount,
        });

        return response.data;
    }

    async deleteAdmin(cafeId, adminId) {
        const response = await API.delete(`/sadmin/managment/deleteAdmin/${adminId}?cafe_id=${cafeId}`);

        return response.data;
    }

    async inviteAdmin(cafeId, expHours = 1) {
        const response = await API.post(`/sadmin/managment/generate-admin-invite`, {
            cafe_id: cafeId,
            expires_hours: expHours,
        })

        return response.data.invite_link;
    }

    async createCafe({ name, address, group, maxEmpCount }) {
        const response = await API.post(`/sadmin/cafe/createCafe`, {
            name: name,
            address: address,
            max_emp_count: maxEmpCount,
            group: group,
        });

        return {
            id: response.data.id,
            name: response.data.name,
            address: response.data.address,
            maxEmpCount: response.data.max_emp_count,
            group: response.data.group,
        }
    }

    async fetchCafeAdminInfo(cafeId) {
        const response = await API.get(`/admin/cafe/${cafeId}/currentAdmin`);

        const adminId = response.data.user_id || response.data.id;

        return {
            userId: adminId,
            cafeId: response.data.cafe_id,
            profilePhotoUrl: response.data.profile_photo_url,
            name: response.data.name,
        };
    }
}

const SuperAdminAPI = new SuperAdminAPIClass();
export default SuperAdminAPI;
